import { render, staticRenderFns } from "./EditableTable.vue?vue&type=template&id=2ae510d5&"
import script from "./EditableTable.vue?vue&type=script&lang=js&"
export * from "./EditableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports